const GMAIL_DOMAINS = ['gmail.com', 'googlemail.com'];

export const getUserIdFromEmail = (email: string): string =>
  email.replace(/[|&;$%@"<>()+,.]/g, '');

export const isGmailAddress = (email: string): boolean => {
  const [, domain] = email.toLowerCase().split('@');
  return GMAIL_DOMAINS.includes(domain);
};
